"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", [_c("el-form", {
    staticStyle: {
      "padding-top": "20px",
      "padding-left": "20px",
      "margin-bottom": "5px"
    },
    attrs: {
      inline: true,
      model: _vm.formInline
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入手机号"
    },
    model: {
      value: _vm.formInline.userphone,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "userphone", $$v);
      },
      expression: "formInline.userphone"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入姓名"
    },
    model: {
      value: _vm.formInline.username,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "username", $$v);
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "订单号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入订单号"
    },
    model: {
      value: _vm.formInline.orderNo,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "orderNo", $$v);
      },
      expression: "formInline.orderNo"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "三方订单号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入订单号"
    },
    model: {
      value: _vm.formInline.three_order,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "three_order", $$v);
      },
      expression: "formInline.three_order"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "蚂蚁链订单号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入订单号"
    },
    model: {
      value: _vm.formInline.alipay_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "alipay_id", $$v);
      },
      expression: "formInline.alipay_id"
    }
  })], 1), _vm._v(" "), _c("el-date-picker", {
    attrs: {
      type: "datetimerange",
      align: "right",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "default-time": ["00:00:00", "24:00:00"]
    },
    model: {
      value: _vm.datenum,
      callback: function callback($$v) {
        _vm.datenum = $$v;
      },
      expression: "datenum"
    }
  }), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "固定时间"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formInline.g_date,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "g_date", $$v);
      },
      expression: "formInline.g_date"
    }
  }, [_c("el-option", {
    attrs: {
      label: "所有",
      value: "0"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.getDateFiveDaysAgo(5),
      value: "1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.getDateFiveDaysAgo(6),
      value: "2"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.getDateFiveDaysAgo(7),
      value: "3"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: _vm.getDateFiveDaysAgo(8),
      value: "4"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "订单状态"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formInline.status,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "status", $$v);
      },
      expression: "formInline.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "所有",
      value: "0"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "申请解约",
      value: "7"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "已完成",
      value: "1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "未完成",
      value: "2"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "已取消",
      value: "3"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "签约类型"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formInline.is_jd,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "is_jd", $$v);
      },
      expression: "formInline.is_jd"
    }
  }, [_c("el-option", {
    attrs: {
      label: "所有",
      value: "-1"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "蚂蚁链订单",
      value: "0"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "京东订单",
      value: "1"
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "small"
    },
    on: {
      click: _vm.goSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "warning",
      icon: "el-icon-refresh-right",
      size: "small"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: "添加投诉信息",
      visible: _vm.is_show_complain,
      width: "80%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.is_show_complain = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "投诉信息截图",
      required: ""
    }
  }, [_c("el-upload", {
    attrs: {
      action: _vm.action,
      "list-type": "picture-card",
      accept: ".jpg,.png,.jpeg,.webp",
      "on-success": function onSuccess(response) {
        _vm.complain_picture.push(response);
      },
      limit: 3
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "投诉信息备注",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "8"
    },
    model: {
      value: _vm.complain_text,
      callback: function callback($$v) {
        _vm.complain_text = $$v;
      },
      expression: "complain_text"
    }
  })], 1), _vm._v(" "), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmitAccount
    }
  }, [_vm._v("上传投诉信息")])], 1)], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticStyle: {
      padding: "0 20px"
    },
    attrs: {
      md: 24
    }
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticClass: "table-box"
  }, [_c("div", {
    staticClass: "table-title"
  }, [_c("div", [_vm._v("订单信息")]), _vm._v(" "), _c("div", [_vm._v("用户信息")]), _vm._v(" "), _c("div", [_vm._v("签约信息")]), _vm._v(" "), _c("div", [_vm._v("授权信息")]), _vm._v(" "), _c("div", [_vm._v("操作")])]), _vm._v(" "), _vm.dataList.results.length > 0 ? _c("div", _vm._l(_vm.dataList.results, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "table-content"
    }, [_c("div", {
      staticClass: "content-title"
    }, [_c("div", {
      class: item.is_jd == 1 ? "is_jd" : "title-box"
    }, [_c("div", {
      staticClass: "title-row"
    }, [_vm._v("序号：" + _vm._s(index + 1))]), _vm._v(" "), _c("div", {
      staticClass: "title-row"
    }, [_vm._v("\n                    订单号： "), _c("span", [_vm._v(_vm._s(item.orderNo))]), _vm._v(" "), _vm.isAdmin && item.is_saas == 0 ? _c("span", [_vm._v("(非)")]) : _vm._e(), _vm._v(" "), _vm.isAdmin && item.is_jd == 1 ? _c("span", [_vm._v("(京)")]) : _vm._e(), _vm._v(" "), _vm.isAdmin && item.is_bd == 1 ? _c("span", [_vm._v("(保)")]) : _vm._e(), _vm._v(" "), _c("span", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.three_order,
        expression: "item.three_order"
      }],
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v("(" + _vm._s(item.three_order) + ")")])]), _vm._v(" "), _c("div", {
      staticClass: "title-row"
    }, [_vm._v("所属商铺：" + _vm._s(item.shop_name))]), _vm._v(" "), _c("div", {
      staticClass: "title-row"
    }, [item.is_cancel == 1 || item.is_history == 1 ? _c("el-tag", {
      attrs: {
        type: "danger"
      }
    }, [_vm._v("已结束")]) : _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("进行中")])], 1), _vm._v(" "), item.complain_num > 0 ? _c("div", {
      staticClass: "title-row",
      staticStyle: {
        color: "red"
      }
    }, [_vm._v(" 订单投诉次数：" + _vm._s(item.complain_num))]) : _vm._e(), _vm._v(" "), item.is_unsign == 1 ? _c("div", {
      staticClass: "title-row",
      staticStyle: {
        color: "red"
      }
    }, [_vm._v("用户申请解约：" + _vm._s(item.unsign_time))]) : _vm._e()])]), _vm._v(" "), _c("div", {
      staticClass: "content-info"
    }, [_c("div", {
      staticClass: "content-info-left"
    }, [_c("div", {
      staticClass: "info-item",
      staticStyle: {
        width: "800px",
        "white-space": "normal"
      }
    }, [_c("div", {
      staticClass: "info_row"
    }, [_vm._v("商品名：" + _vm._s(item.goods_name))]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("创建时间：" + _vm._s(item.create_time))]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("商品id：" + _vm._s(item.good))]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("首付扣款总额：" + _vm._s(item.shou_money) + "元")]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("首付扣款期数：" + _vm._s(item.shou_cost_num) + "期")])]), _vm._v(" "), _c("div", {
      staticClass: "info-item"
    }, [_c("div", {
      staticClass: "info_row"
    }, [_vm._v("姓名：" + _vm._s(item.user.real_name))]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("手机号：" + _vm._s(item.user.mobile))]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("已完成扣款期数：" + _vm._s(item.hk_ok_num) + "期")]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("用户已划扣金额：" + _vm._s(item.hk_ok_money ? _vm.formatNum(item.hk_ok_money, 2) : 0) + "元")]), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("用户投诉总次数：" + _vm._s(item.user.complain_num) + "次")])]), _vm._v(" "), _c("div", {
      staticClass: "info-item"
    }, [_c("div", {
      staticClass: "info_row"
    }, [_vm._v("租赁合同状态：\n                      "), item.is_esign_contract == false ? _c("el-tag", {
      attrs: {
        type: "danger"
      }
    }, [_vm._v("未签署")]) : _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("已签署")])], 1), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("代扣协议状态：\n                      "), item.is_alipay_contract == false ? _c("el-tag", {
      attrs: {
        type: "danger"
      }
    }, [_vm._v("未签署")]) : _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("已签署")])], 1), _vm._v(" "), _c("div", {
      staticClass: "info_row"
    }, [_vm._v("\n                      已支付金额：" + _vm._s(_vm.formatNum(item.pay_money, 2)) + "元\n                    ")])]), _vm._v(" "), _c("div", {
      staticClass: "info-item"
    }, [_c("div", {
      staticStyle: {
        display: "flex",
        "flex-direction": "column"
      }
    }, [_vm._v("授权支付宝昵称：\n                      "), item.user.nick_name ? _c("div", {
      staticClass: "info_row"
    }, [_vm._v(_vm._s(item.user.nick_name))]) : _c("div", {
      staticClass: "info_row"
    }, [_vm._v("未知")])]), _vm._v(" "), _c("div", {
      staticStyle: {
        display: "flex",
        "flex-direction": "column"
      }
    }, [_vm._v("授权支付宝头像：\n                      "), item.user.avater ? _c("img", {
      staticStyle: {
        width: "60px",
        height: "60px"
      },
      attrs: {
        src: item.user.avater,
        alt: ""
      }
    }) : _c("div", {
      staticClass: "info_row"
    }, [_vm._v("未知")])])])]), _vm._v(" "), _c("div", {
      staticClass: "content-info-right"
    }, [_c("div", {
      staticClass: "info-item"
    }, [_c("el-button", {
      attrs: {
        type: "primary",
        size: "small",
        icon: "el-icon-news"
      },
      on: {
        click: function click($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_vm._v(" 详 情")]), _vm._v(" "), _c("el-button", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.is_esign_contract == true,
        expression: "item.is_esign_contract ==true"
      }],
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        type: "info",
        size: "small"
      },
      on: {
        click: function click($event) {
          return _vm.handleList(item);
        }
      }
    }, [_vm._v("分期计划")]), _vm._v(" "), _vm.isAdmin ? _c("el-button", {
      staticStyle: {
        "margin-top": "5rpx"
      },
      attrs: {
        type: "danger",
        size: "small",
        icon: "el-icon-news"
      },
      on: {
        click: function click($event) {
          return _vm.show_complain(item);
        }
      }
    }, [_vm._v("添加投诉信息")]) : _vm._e(), _vm._v(" "), item.is_unsign == 1 && item.is_cancel == 1 ? _c("el-button", {
      attrs: {
        type: "danger",
        size: "small",
        icon: "el-icon-news"
      },
      on: {
        click: function click($event) {
          return _vm.setSycn(item, 1);
        }
      }
    }, [_vm._v("同意解约")]) : _vm._e(), _vm._v(" "), item.is_unsign == 1 ? _c("el-button", {
      attrs: {
        type: "primary",
        size: "small",
        icon: "el-icon-news"
      },
      on: {
        click: function click($event) {
          return _vm.setSycn(item, 2);
        }
      }
    }, [_vm._v("拒绝解约")]) : _vm._e()], 1)])])]);
  }), 0) : _c("div", {
    staticClass: "no-data"
  }, [_vm._v("\n            暂无数据\n          ")])]), _vm._v(" "), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataList.count > 0,
      expression: "dataList.count > 0"
    }],
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    },
    attrs: {
      total: _vm.dataList.count,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.page_size
    },
    on: {
      "update:page": function updatePage($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function updateLimit($event) {
        return _vm.$set(_vm.listQuery, "page_size", $event);
      },
      pagination: _vm.getOrderList
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;